// extracted by mini-css-extract-plugin
module.exports = {"container":"Hit_container__sf0kC","imageWrapper":"Hit_imageWrapper__9RwIL","image":"Hit_image__FPF0q","placeholder":"Hit_placeholder__r_OyF","title":"Hit_title__fUil0"};